import React, { useEffect, useState } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2 } from 'lucide-react';
import AuthShell from '../components/auth/AuthShell';

const API = `${window.location.origin}/api`;

export default function CheckEmail() {
  const location = useLocation();
  const email = location.state?.email;
  const inviteContext = location.state?.inviteContext;

  const [cooldown, setCooldown] = useState(0);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  if (!email) {
    return <Navigate to="/register" replace />;
  }

  const handleResend = async () => {
    if (resending || cooldown > 0) return;
    setResending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, { email });
      toast.success('Doğrulama maili tekrar gönderildi');
      setCooldown(60);
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === 'string' ? detail : 'Mail gönderilemedi';
      toast.error(msg);
    } finally {
      setResending(false);
    }
  };

  return (
    <AuthShell>
      <div className="ll-hero" style={{ marginBottom: 24 }}>
        <div style={{
          width: 56,
          height: 56,
          borderRadius: 14,
          background: 'var(--accent-weak, rgba(126,182,240,.15))',
          color: 'var(--accent)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 18,
        }}>
          <Mail size={26} />
        </div>
        <h1>E-postanı kontrol et.</h1>
        <p className="ll-sub">
          <strong style={{ color: 'var(--text)' }}>{email}</strong> adresine bir doğrulama linki gönderdik.
          Hesabını aktifleştirmek için linke tıkla.
        </p>
      </div>

      {inviteContext && inviteContext.workspaceName && (
        <div style={{
          background: 'linear-gradient(135deg, rgba(126,182,240,.08) 0%, rgba(126,182,240,.02) 100%)',
          border: '1px solid var(--accent)',
          borderRadius: 10,
          padding: 12,
          marginBottom: 18,
          fontSize: 12.5,
          color: 'var(--text)',
          lineHeight: 1.55,
        }}>
          Doğrulama sonrası <strong>{inviteContext.workspaceName}</strong> workspace'ine otomatik katılacaksın.
        </div>
      )}

      <div style={{
        background: 'var(--surface-muted)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: 14,
        marginBottom: 18,
        fontSize: 12,
        color: 'var(--text-muted)',
        lineHeight: 1.6,
      }}>
        Mail birkaç dakika içinde gelmediyse spam/junk klasörünü kontrol et. Yine de bulamazsan aşağıdan tekrar gönderebilirsin.
      </div>

      <button
        type="button"
        className="ll-ghost"
        onClick={handleResend}
        disabled={resending || cooldown > 0}
        style={{ width: '100%', cursor: cooldown > 0 || resending ? 'not-allowed' : 'pointer' }}
      >
        {resending ? <Loader2 size={14} className="animate-spin" /> : null}
        <span>
          {cooldown > 0
            ? `Tekrar gönder (${cooldown}s)`
            : resending
              ? 'Gönderiliyor…'
              : 'Doğrulama mailini tekrar gönder'}
        </span>
      </button>

      <div style={{ textAlign: 'center', marginTop: 18 }}>
        <Link to="/" style={{ fontSize: 12.5, color: 'var(--accent)', textDecoration: 'none' }}>
          ← Giriş sayfasına dön
        </Link>
      </div>
    </AuthShell>
  );
}
